/**
 * Type guard that verifies if a given node is a text node.
 */
export function isTextNode(node: Node): node is Text {
    return node.nodeType === node.TEXT_NODE;
}
